<template>
  <div id="admin" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo admintitulo">Usuario administrador del sistema</v-row>
      <v-row no-gutters class="datos admindatos">
        <v-col cols="12" sm="12" class="formsa">
            <div class="form-group">
              <label for="nombre">Nombre(s)</label>
              <input type="text" name="nombre" id="nombre" v-model="datos[0].nombre" />
              <label for="apep">Apellido Paterno</label>
              <input type="text" name="app" id="apep" v-model="datos[0].apep" />
              <label for="apm">Apellido Materno</label>
              <input type="text" name="apm" id="apm" v-model="datos[0].apem" />
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" name="email" id="email" v-model="datos[0].email" />
              <label for="tel">Telefóno</label>
              <input type="text" name="tel" id="tel" v-model="datos[0].tel" />
              <label for="fecha">Fecha de nacimiento</label>
              <input type="date" name="fecha" id="fecha" v-model="datos[0].fecha" />
            </div>
            <div class="form-group escondido">
              <label for="genero">Género</label>
              <div class="text-center">
                <input
                  type="radio"
                  id="mujer"
                  name="genero"
                  class="text-center forms"
                  :checked="datos[0].genero=='Femenino'"
                />
                <label for="mujer" class="radio-inline" style="margin-right: 15px;">
                  <span class="fa-2x">
                    <font-awesome-icon icon="female" />
                  </span>
                </label>
                <input
                  type="radio"
                  id="hombre"
                  name="genero"
                  :checked="datos[0].genero=='Masculino'"
                />
                <label for="hombre" class="radio-inline">
                  <span class="fa-2x">
                    <font-awesome-icon icon="male" />
                  </span>
                </label>
              </div>
            </div>
            <div class="text-sm-start">
              <div class="text-center">
                <button
                  class="mt-6 mx-10 boton"
                  style="float:none !important;font-size:1em;"
                  @click="siguiente()"
                >Siguiente</button>
              </div>
            </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader
  },
  data() {
    return {
      show: false,
      step: "Instalador de nuevo cliente",
      stepn: "2-N",
      datos: [
        {
          id: 1,
          nombre: "Jorge",
          apep: "Garcia",
          apem: "Juarez",
          tel: "5558858585",
          email: "jogaju@gmail.com",
          fecha: "19/05/1985",
          genero: "Masculino",
        },
      ],
    };
  },
  methods: {
    nombre() {
      localStorage.step = this.step;
      localStorage.stepn = this.stepn;
    },
    siguiente(){
        this.$router.push("/commercial");
    }
  },
  created() {
    this.nombre();
  },
};
</script>
